/**
 * Color palette for comparison charts (max 3 entities)
 */

export interface ComparisonColor {
  primary: string;
  gradient: string[];
}

export const COMPARISON_COLORS: ComparisonColor[] = [
  {
    primary: "#00c889",
    gradient: ["#bbf7d0", "#86efac", "#22c55e", "#16a34a"],
  },
  {
    primary: "#3b82f6",
    gradient: ["#bfdbfe", "#93c5fd", "#3b82f6", "#2563eb"],
  },
  {
    primary: "#f59e0b",
    gradient: ["#fde68a", "#fcd34d", "#f59e0b", "#d97706"],
  },
];

/**
 * Get color for an entity by its index
 */
export const getEntityColor = (index: number): ComparisonColor => {
  return COMPARISON_COLORS[index % COMPARISON_COLORS.length];
};
